import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const SettingsContext = createContext({ settings: null });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await http.get("/settings");
      setSettings(data);
    } catch (e) {
      console.error("Failed to load settings", e);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
